// src/pages/NominationsPage.jsx
import React from 'react';
import IntroImage from '../images/BAir-M_Bus-37_Single-10.jpg';
import CMOIcon from '../images/report_12442087.svg';
import StrategicIcon from '../images/idea_12423011.svg';
import GlobalIcon from '../images/incumbent_18130812.svg';
import BrandIcon from '../images/convert_7444812.svg';
import DataIcon from '../images/data-driven_12238554.svg';
import ImpactIcon from '../images/statistics_12655555.svg';
import CrossCulturalIcon from '../images/diversity_17755205.svg';
import InnovationIcon from '../images/innovation_8840777.svg';
import ReputationIcon from '../images/thumbs-up_18015553.svg';
import SustainabilityIcon from '../images/organic-reach_18874290.svg';
import TeamIcon from '../images/team_7261593.svg';
import PinIcon from '../images/point_13671221.svg';
import CheckIcon from '../images/checked_339818.svg';
import ListIcon from '../images/list_8446544.svg';

export default function NominationsPage() {
  return (
    <article className="terms-page">


            <section className="section-organizer jury-policy__intro">
        <h1 className="section-title">Номинации и критерии оценки Международной премии International CMO Summit Awards</h1>
        <p className="jury-policy__subtitle">
          Премия International CMO Summit Awards признана на международном уровне как ведущая профессиональная награда в сфере маркетинга. Процесс отбора номинантов осуществляется по системе double-blind (двойного слепого рецензирования): члены жюри не знают личностей участников, а участники — состав жюри. Все члены жюри являются международными экспертами в области маркетинга, не связанными с участниками ни профессионально, ни лично, что подтверждается подписанием соглашений о неаффилированности и конфиденциальности. Каждая заявка проходит многоэтапную анонимную экспертизу, при этом члены жюри не имеют права оценивать заявки из стран или компаний, с которыми у них могут быть связи, что исключает конфликт интересов.
        </p>
          <div className="jury-policy__intro-image">
          <img src={IntroImage} alt="Победители International CMO Summit Awards" />
        </div>
      </section>


      <section className="terms-section">
        <h2 className="terms-section__title">
          <img src={CMOIcon} alt="" className="terms-section__icon" />
          CMO of the Year
        </h2>
        <p>
          Главная индивидуальная награда международной премии, присуждаемая за исключительное стратегическое лидерство, значительное влияние на рост бизнеса, трансформацию бренда и вклад в развитие маркетинговой индустрии.
        </p>
        <h3><img src={PinIcon} alt="" className="terms-section__pin-icon" />
         Описание номинации</h3>
        <p>
          Награда предназначена для Chief Marketing Officer, чья работа оказала доказуемо ключевое влияние на стратегию компании, рост капитализации, международную узнаваемость бренда и преобразование корпоративной культуры. Эта награда подтверждает исключительный профессиональный уровень, признанный международным жюри по итогам конкурентного и анонимного оценивания заявок.
        </p>
        <h3>
            <img src={CheckIcon} alt="" className="terms-section__pin-icon" />
             Критерии оценки:</h3>
        <ul className="terms-list">
          <li>Финансово подтвержденный вклад в бизнес:</li>
          <ul className="terms-list">
            <li>Доказанный рост выручки, рыночной доли, EBITDA, капитализации или ROMI, непосредственно связанный с инициативами CMO.</li>
            <li>Подтверждение через P&L отчёты, BI-дашборды, внешнюю аналитику.</li>
          </ul>
          <li>Индивидуальное лидерство на стратегическом уровне:</li>
          <ul className="terms-list">
            <li>Участие в разработке или пересмотре стратегии компании на уровне совета директоров/CEO.</li>
            <li>Примеры решений, повлиявших на долгосрочное развитие компании (3+ лет).</li>
          </ul>
          <li>Международное и национальное влияние:</li>
          <ul className="terms-list">
            <li>Реализация маркетинговых кампаний с подтвержденным эффектом в нескольких странах или масштабных национальных проектов с публичным признанием.</li>
            <li>Подтверждение масштабов охвата, результатов по KPI, PR-индексов, узнаваемости и вовлечённости.</li>
          </ul>
          <li>Командное управление и масштаб ответственности:</li>
          <ul className="terms-list">
            <li>Руководство мультифункциональными и мультинациональными командами (10+ человек), включая агентства и подрядчиков.</li>
            <li>Описание организационной структуры и управленческих практик.</li>
          </ul>
          <li>Международное профессиональное признание:</li>
          <ul className="terms-list">
            <li>Участие в профильных международных конференциях, форумах;</li>
            <li>Публикации в авторитетных профессиональных и научных изданиях;</li>
          </ul>
          <li>Влияние на корпоративную культуру:</li>
          <ul className="terms-list">
            <li>Продвижение ценностей DEI (diversity, equity, inclusion), устойчивого развития, внутренних трансформационных инициатив через маркетинг.</li>
          </ul>
        </ul>
        <h3><img src={ListIcon} alt="" className="terms-section__pin-icon" />
         Формат подачи заявки (submission requirements):</h3>
        <ul className="terms-list">
          <li>Личное описание роли, зоны ответственности и стратегических задач;</li>
          <li>Доказательства бизнес-результатов: финансовая отчётность, BI-отчёты, кейсы с визуализациями, публикации;</li>
          <li>Подтверждённые стратегические инициативы: roadmaps, документы из корпоративного стратегического плана;</li>
          <li>Рекомендательные письма от CEO, членов совета директоров, внешних партнёров;</li>
        </ul>
      </section>

      {/* Strategic Visionary of the Year */}
      <section className="terms-section">
                <h2 className="terms-section__title">
          <img src={StrategicIcon} alt="" className="terms-section__icon" />
          Strategic Visionary of the Year
        </h2>
        <p>
          Индивидуальная награда международной премии, присуждаемая за выдающееся стратегическое мышление, дальновидность и значительное влияние на устойчивое развитие бизнеса, его трансформацию и адаптацию к глобальным вызовам.
        </p>
        <h3><img src={PinIcon} alt="" className="terms-section__pin-icon" />
         Описание номинации</h3>
        <p>
          Награда предназначена для Chief Marketing Officer, который не только руководил маркетинговыми функциями, но и сформировал или трансформировал стратегическое направление всей компании, включая бизнес-модель, рыночную позицию и операционные процессы. Такой лидер демонстрирует способность видеть будущее, управлять неопределённостью и добиваться устойчивых конкурентных преимуществ. Оценка проводится международным жюри по итогам анонимного конкурсного отбора.
        </p>
        <h3>
            <img src={CheckIcon} alt="" className="terms-section__pin-icon" />
             Критерии оценки:</h3>
        <ul className="terms-list">
          <li>Формирование долгосрочной стратегии компании:</li>
          <ul className="terms-list">
            <li>Разработка или трансформация маркетинговой стратегии с горизонтом 3+ лет;</li>
            <li>Интеграция маркетинга в стратегию всей компании на уровне C-suite или совета директоров.</li>
          </ul>
          <li>Подтверждённое влияние на устойчивый рост бизнеса:</li>
          <ul className="terms-list">
            <li>Рост выручки, рыночной капитализации, клиентской базы или выхода на новые рынки;</li>
            <li>Подтверждение через P&L, внешнюю аналитику, BI-инструменты.</li>
          </ul>
          <li>Инновационный подход и адаптация к глобальным вызовам:</li>
          <ul className="terms-list">
            <li>Кейсы по антикризисному управлению, цифровой трансформации, гибридным моделям развития;</li>
            <li>Использование foresight-подходов и анализ будущих рыночных сценариев.</li>
          </ul>
          <li>Признание профессионального сообщества:</li>
          <ul className="terms-list">
            <li>Публикации, аналитические колонки, лидерство в отраслевых стратегических дискуссиях;</li>
            <li>Участие в международных саммитах, форумах, членство в стратегических комитетах и think-tanks.</li>
          </ul>
          <li>Управление изменениями и вовлечённость команды:</li>
          <ul className="terms-list">
            <li>Проведение организационных преобразований, развитие лидерской культуры;</li>
            <li>Внедрение принципов устойчивого роста (sustainability, ESG, agile-гибкость).</li>
          </ul>
        </ul>
        <h3><img src={ListIcon} alt="" className="terms-section__pin-icon" />
         Формат подачи заявки (submission requirements):</h3>
        <ul className="terms-list">
          <li>Личное описание роли, масштаба влияния и стратегических инициатив;</li>
          <li>Подтверждённые результаты: финансовая отчётность, внешняя аналитика, BI-дашборды, презентации, кейсы;</li>
          <li>Документы и визуализации стратегических решений: стратегические дорожные карты, внутренние доклады, стратегические инициативы, брифы;</li>
          <li>Рекомендательные письма от CEO, стратегических партнёров, членов совета директоров;</li>
          <li>Публичные подтверждения: медиа-упоминания, интервью, выступления, участие в экспертных сообществах.</li>
        </ul>
      </section>

      {/* Global Marketing Leader */}
      <section className="terms-section">
        <h2 className="terms-section__title">
          <img src={GlobalIcon} alt="" className="terms-section__icon" />
          Global Marketing Leader
        </h2>
        <p>
          Индивидуальная награда, присуждаемая за выдающееся управление международным маркетингом, координацию кросс-региональных команд и достижение высоких бизнес-результатов в мультикультурной среде.
        </p>
                <h3><img src={PinIcon} alt="" className="terms-section__pin-icon" />
         Описание номинации</h3>
        <p>
          Награда предназначена для маркетингового директора (CMO), который успешно реализует глобальные маркетинговые стратегии, эффективно управляет транснациональными командами и обеспечивает устойчивое позиционирование бренда на международных рынках. Лауреаты демонстрируют лидерство в адаптации бренда к различным рыночным реалиям и культурам.
        </p>
        <h3>
            <img src={CheckIcon} alt="" className="terms-section__pin-icon" />
             Критерии оценки:</h3>
        <ul className="terms-list">
          <li>Международный охват и адаптация стратегии:</li>
          <ul className="terms-list">
            <li>Подтверждённая реализация маркетинговых кампаний в 5+ странах;</li>
            <li>Адаптация глобальной стратегии под региональные особенности, локальные потребительские предпочтения и законодательные рамки.</li>
          </ul>
          <li>Стратегическое управление международными командами:</li>
          <ul className="terms-list">
            <li>Руководство региональными и локальными маркетинговыми подразделениями;</li>
            <li>Координация международных агентств, локальных подрядчиков, дистрибьюторов.</li>
          </ul>
          <li>Результаты и метрики по регионам:</li>
          <ul className="terms-list">
            <li>Доказанный рост выручки, охвата, узнаваемости и клиентской базы в ключевых странах;</li>
            <li>Представлены отчеты, KPI, метрики по регионам.</li>
          </ul>
          <li>Международное признание и участие:</li>
          <ul className="terms-list">
            <li>Участие в международных форумах, конференциях, отраслевых ассоциациях;</li>
            <li>Публикации и кейсы в международных медиа и платформах.</li>
          </ul>
          <li>Вклад в глобальное позиционирование бренда:</li>
          <ul className="terms-list">
            <li>Обеспечение консистентности позиционирования бренда по всем регионам;</li>
            <li>Использование культурно-чувствительных коммуникаций.</li>
          </ul>
        </ul>
        <h3><img src={ListIcon} alt="" className="terms-section__pin-icon" />
         Формат подачи заявки (submission requirements):</h3>
        <ul className="terms-list">
          <li>География охвата: карта, перечень стран, где присутствует бренд;</li>
          <li>Описание ключевых международных кампаний: цели, реализация, результаты;</li>
          <li>Подтвержденные финансовые и маркетинговые метрики по регионам;</li>
          <li>Организационная структура и описание командного взаимодействия;</li>
          <li>Пресс-релизы, публикации, внешние подтверждения (ссылки на СМИ, отчёты, платформы).</li>
        </ul>
      </section>

      {/* Brand Transformation Architect */}
      <section className="terms-section">
                <h2 className="terms-section__title">
          <img src={BrandIcon} alt="" className="terms-section__icon" />
          Brand Transformation Architect
        </h2>
        <p>
          Индивидуальная награда международной премии за системное управление трансформацией бренда, включая стратегический ребрендинг, репозиционирование и обновление визуальной и ценностной идентичности компании.
        </p>
                <h3><img src={PinIcon} alt="" className="terms-section__pin-icon" />
         Описание номинации</h3>
        <p>
          Награда предназначена для Chief Marketing Officer, который провёл масштабную трансформацию бренда, повлиявшую на восприятие компании на рынке, внутри команды и среди стейкхолдеров. В фокусе — системная работа с бренд-архитектурой, коммуникацией, визуальным стилем и repositioning-стратегией, подтверждённая измеримыми результатами.
        </p>
        <h3>
            <img src={CheckIcon} alt="" className="terms-section__pin-icon" />
             Критерии оценки:</h3>
        <ul className="terms-list">
          <li>Масштаб и значимость трансформации:</li>
          <ul className="terms-list">
            <li>Стратегическая необходимость трансформации (кризис, рост, смена позиционирования, выход на новые рынки).</li>
            <li>Подтверждение значимости задачи через внутренние документы, аналитические материалы, медиа/отзывы.</li>
          </ul>
          <li>Креативная и стратегическая реализация:</li>
          <ul className="terms-list">
            <li>Разработка новой бренд-платформы, tone of voice, ценностного ядра, визуальной айдентики.</li>
            <li>Вовлечение ключевых подразделений и внешних агентств в процесс трансформации.</li>
          </ul>
          <li>Рынок и восприятие бренда:</li>
          <ul className="terms-list">
            <li>Положительная динамика brand metrics: awareness, NPS, loyalty, consideration, trust.</li>
            <li>Реакция рынка, клиентов и партнёров на проведённые изменения.</li>
          </ul>
          <li>Внутреннее восприятие и корпоративная интеграция:</li>
          <ul className="terms-list">
            <li>Интеграция новой идентичности в корпоративную культуру, HR-бренд, офисные пространства.</li>
            <li>Роль CMO в трансформации внутренних коммуникаций и укреплении бренд-ценностей в команде.</li>
          </ul>
          <li>Публичное признание и профессиональная оценка:</li>
          <ul className="terms-list">
            <li>Упоминания в профильных и деловых медиа, кейсы агентств, награды за дизайн и брендинг.</li>
            <li>Участие проекта в конференциях, фестивалях, профессиональных публикациях.</li>
          </ul>
        </ul>
        <h3><img src={ListIcon} alt="" className="terms-section__pin-icon" />
         Формат подачи заявки (submission requirements):</h3>
        <ul className="terms-list">
          <li>Личное описание роли, зоны ответственности и масштаба трансформации;</li>
          <li>Документация до/после: бренд-платформы, визуальные материалы, презентации, исследования;</li>
          <li>Метрики и аналитика: результаты по KPI, вовлечённости, отзывам, PR;</li>
          <li>Отзывы и подтверждения: от руководства, агентств, клиентов, внутренние опросы;</li>
          <li>Публичные подтверждения: публикации в СМИ, профессиональные награды, спикерство на конференциях.</li>
        </ul>
      </section>

      {/* Data-Driven Decision Maker */}
      <section className="terms-section">
                        <h2 className="terms-section__title">
          <img src={DataIcon} alt="" className="terms-section__icon" />
          Data-Driven Decision Maker
        </h2>
        <p>
          Награда за выдающееся применение аналитики и данных в построении стратегий маркетинга, оптимизации процессов и принятии управленческих решений.
        </p>
                <h3><img src={PinIcon} alt="" className="terms-section__pin-icon" />
         Описание номинации</h3>
        <p>
          Номинация присуждается Chief Marketing Officer, который интегрировал аналитические подходы в маркетинг и обеспечил рост эффективности на основе данных. Это CMO, способный использовать BI, CDP, DMP, LTV, CAC и другие инструменты для точного анализа поведения потребителей, персонализации коммуникаций и масштабируемого роста бизнеса.
        </p>
        <h3>
            <img src={CheckIcon} alt="" className="terms-section__pin-icon" />
             Критерии оценки:</h3>
        <ul className="terms-list">
          <li>Внедрение аналитических платформ и инструментов:</li>
          <ul className="terms-list">
            <li>Интеграция BI-систем, CDP, DMP, ML-моделей, предиктивной аналитики и дашбордов;</li>
            <li>Создание системы регулярной оценки маркетинговых инициатив на основе данных.</li>
          </ul>
          <li>Измеримое влияние на бизнес:</li>
          <ul className="terms-list">
            <li>Оптимизация ROMI, снижение CAC, повышение LTV, контроль churn rate;</li>
            <li>Влияние аналитики на прибыльность, бюджеты, приоритезацию каналов и рост выручки.</li>
          </ul>
          <li>Прозрачность и культура принятия решений:</li>
          <ul className="terms-list">
            <li>Обеспечение доступности и интерпретируемости данных для всех участников команды;</li>
            <li>Обучение и внедрение культуры data-driven в маркетинговом подразделении.</li>
          </ul>
          <li>Личное участие CMO:</li>
          <ul className="terms-list">
            <li>Разработка метрик, KPI, формирование стратегии на основе аналитики;</li>
            <li>Участие в построении архитектуры данных и внедрении сквозной аналитики.</li>
          </ul>
        </ul>
        <h3><img src={ListIcon} alt="" className="terms-section__pin-icon" />
         Формат подачи заявки (submission requirements):</h3>
        <ul className="terms-list">
          <li>Описание внедрённой системы аналитики, архитектуры и бизнес-целей;</li>
          <li>Примеры дашбордов, моделей, KPI и отчётов;</li>
          <li>Документы, показывающие влияние на ROMI, бюджеты, прибыльность и стратегию;</li>
          <li>Отзывы команды, партнёров, аналитических агентств (по возможности);</li>
          <li>Публикации, признание кейса в отраслевом сообществе, ссылки на BI-интерфейсы или визуализации.</li>
        </ul>
      </section>

      {/* CMO Impact Award */}
      <section className="terms-section">
        <h2 className="terms-section__title">
          <img src={ImpactIcon} alt="" className="terms-section__icon" />
          CMO Impact Award
        </h2>
        <p>
          Главная награда за доказанный вклад маркетинга в бизнес-результаты, присуждаемая за прямое влияние CMO на выручку, прибыль, рыночную долю и другие ключевые показатели эффективности компании.
        </p>
                <h3><img src={PinIcon} alt="" className="terms-section__pin-icon" />
         Описание номинации</h3>
        <p>
          Награда предназначена для Chief Marketing Officer, чьи инициативы привели к существенному росту финансовых и операционных метрик компании. Она присуждается маркетинговым лидерам, способным доказать влияние маркетинга на бизнес, подтверждённое цифрами, отчётами и признанием коллег по индустрии.
        </p>
        <h3>
            <img src={CheckIcon} alt="" className="terms-section__pin-icon" />
             Критерии оценки:</h3>
        <ul className="terms-list">
          <li>Финансово измеримый вклад маркетинга в рост компании:</li>
          <ul className="terms-list">
            <li>Подтверждённое влияние на ключевые показатели бизнеса: выручку, прибыль, P&L, долю рынка, ROMI.</li>
            <li>Связь между реализованными маркетинговыми инициативами и ростом этих показателей.</li>
          </ul>
          <li>Интеграция маркетинга с другими функциями:</li>
          <ul className="terms-list">
            <li>Совместная работа с коммерческими, финансовыми, продуктовыми и клиентскими подразделениями.</li>
            <li>Внедрение процессов, усиливающих вклад маркетинга в общий результат компании.</li>
          </ul>
          <li>Подтверждённые кейсы роста:</li>
          <ul className="terms-list">
            <li>Конкретные проекты, повлиявшие на показатели по направлениям продаж, удержания клиентов, LTV и др.</li>
            <li>Использование BI-дашбордов, аналитики, ROI-калькуляций, внешней отчётности.</li>
          </ul>
          <li>Признание и прозрачность результатов:</li>
          <ul className="terms-list">
            <li>Пресс-релизы, годовые отчёты, выступления на конференциях, участие в отраслевых обзорах.</li>
            <li>Внешние публикации и освещение успешных кейсов в медиа.</li>
          </ul>
        </ul>
        <h3><img src={ListIcon} alt="" className="terms-section__pin-icon" />
         Формат подачи заявки (submission requirements):</h3>
        <ul className="terms-list">
          <li>Личное описание роли и зоны ответственности;</li>
          <li>Финансовые и аналитические документы, подтверждающие вклад (P&L, дашборды, KPI);</li>
          <li>Кейсы реализованных инициатив с визуализациями и аналитикой;</li>
          <li>Письма от CEO, CFO, членов совета директоров или внешних партнёров;</li>
          <li>Публикации, пресс-релизы, скриншоты или ссылки на медийное признание.</li>
        </ul>
      </section>

      {/* Cross-Cultural Communication Champion */}
      <section className="terms-section">
        <h2 className="terms-section__title">
          <img src={CrossCulturalIcon} alt="" className="terms-section__icon" />
         Cross-Cultural Communication Champion
        </h2>
        <p>
          Награда за исключительное мастерство в управлении коммуникацией бренда в мультикультурной среде и адаптации маркетинговых стратегий к разным рынкам.
        </p>
                <h3><img src={PinIcon} alt="" className="terms-section__pin-icon" />
         Описание номинации</h3>
        <p>
          Номинация присуждается Chief Marketing Officer, который продемонстрировал выдающиеся способности в создании эффективных маркетинговых стратегий, адаптированных под культурные, поведенческие и языковые особенности разных стран. Эта награда отмечает тех лидеров, чьи действия усиливают глобальное присутствие бренда и обеспечивают локальную релевантность.
        </p>
        <h3>
            <img src={CheckIcon} alt="" className="terms-section__pin-icon" />
             Критерии оценки:</h3>
        <ul className="terms-list">
          <li>Масштаб культурного охвата:</li>
          <ul className="terms-list">
            <li>Количество стран, регионов и культур, в которых велась активная коммуникация.</li>
            <li>Адаптация контента, креативов и ценностного предложения под локальные особенности.</li>
          </ul>
          <li>Успешная локализация кампаний:</li>
          <ul className="terms-list">
            <li>Кейсы успешной локализации маркетинговых стратегий с подтверждёнными результатами.</li>
            <li>Использование языковых, визуальных и поведенческих кодов соответствующих рынков.</li>
          </ul>
          <li>Межрегиональная координация:</li>
          <ul className="terms-list">
            <li>Эффективное управление региональными командами и агентствами.</li>
            <li>Настройка процессов, обеспечивающих единое позиционирование при учёте культурных различий.</li>
          </ul>
          <li>Влияние и признание:</li>
          <ul className="terms-list">
            <li>Участие в решении межкультурных кризисов, кейсы успешного реагирования.</li>
            <li>Отзывы региональных директоров, партнёров и потребителей.</li>
          </ul>
        </ul>
        <h3><img src={ListIcon} alt="" className="terms-section__pin-icon" />
         Формат подачи заявки (submission requirements):</h3>
        <ul className="terms-list">
          <li>Описание мультикультурной стратегии и роли CMO в её реализации;</li>
          <li>Примеры адаптированных креативов, локализованных кампаний;</li>
          <li>Результаты по регионам (KPI, PR-охват, узнаваемость, NPS);</li>
          <li>Отзывы локальных команд, рекомендации от международных партнёров;</li>
          <li>Публикации в СМИ, кейсы по межкультурной коммуникации.</li>
        </ul>
      </section>

      {/* Innovation Catalyst in Marketing */}
      <section className="terms-section">
        <h2 className="terms-section__title">
          <img src={InnovationIcon} alt="" className="terms-section__icon" />
         Innovation Catalyst in Marketing
        </h2>
        <p>
          Награда за внедрение прорывных решений и нестандартных подходов, изменивших представление о маркетинге в компании, отрасли или регионе.
        </p>
                <h3><img src={PinIcon} alt="" className="terms-section__pin-icon" />
         Описание номинации</h3>
        <p>
          Присуждается CMO, который стал катализатором изменений, внедрив инновационные технологии, платформы, модели или форматы взаимодействия с аудиторией. Это лидер, способный трансформировать традиционные подходы к маркетингу и вдохновлять индустрию на переосмысление стандартов через эксперименты, digital-инновации, AI, AR/VR, Web3, CX и другие технологии.
        </p>
        <h3>
            <img src={CheckIcon} alt="" className="terms-section__pin-icon" />
             Критерии оценки:</h3>
        <ul className="terms-list">
          <li>Внедрение инновационных решений:</li>
          <ul className="terms-list">
            <li>Использование новых технологических платформ, форматов, цифровых решений (AI, ML, AR/VR, blockchain, Web3, нейросети);</li>
            <li>Разработка или адаптация внутренних маркетинговых инструментов/систем с инновационным подходом.</li>
          </ul>
          <li>Подтверждённое влияние на эффективность:</li>
          <ul className="terms-list">
            <li>Измеримые показатели роста вовлечённости, конверсии, узнаваемости, ROMI и других KPI после внедрения инноваций;</li>
            <li>Экономический или имиджевый эффект от использования новых решений.</li>
          </ul>
          <li>Личное участие и лидерство:</li>
          <ul className="terms-list">
            <li>Инициирование изменений, руководство инновационными процессами, защита проекта на совете директоров;</li>
            <li>Формирование инновационной культуры в отделе маркетинга или во всей компании.</li>
          </ul>
          <li>Признание и тиражирование кейса:</li>
          <ul className="terms-list">
            <li>Публикации о проекте в СМИ, включение в шортлисты или победы в отраслевых премиях;</li>
            <li>Запросы на консалтинг, партнёрства или внедрение модели другими компаниями.</li>
          </ul>
        </ul>
        <h3><img src={ListIcon} alt="" className="terms-section__pin-icon" />
         Формат подачи заявки (submission requirements):</h3>
        <ul className="terms-list">
          <li>Описание инновационного решения, процесса внедрения и роли CMO;</li>
          <li>Доказательства эффективности: цифры, дашборды, BI-отчёты, сравнительная аналитика;</li>
          <li>Документация по проекту (презентации, схемы, описания, roadmap);</li>
          <li>Рекомендации от партнёров, членов совета директоров, CIO, CTO и др.;</li>
          <li>Публикации, выступления, отраслевые обзоры или премии, полученные проектом.</li>
        </ul>
      </section>

      {/* Reputation & Trust Builder */}
      <section className="terms-section">
        <h2 className="terms-section__title">
          <img src={ReputationIcon} alt="" className="terms-section__icon" />
         Reputation & Trust Builder
        </h2>
        <p>
          Награда за выдающееся управление репутацией, доверительным капиталом бренда и построение устойчивых коммуникационных стратегий в условиях внешних вызовов.
        </p>
                <h3><img src={PinIcon} alt="" className="terms-section__pin-icon" />
         Описание номинации</h3>
        <p>
          Присуждается CMO, чьи действия сыграли ключевую роль в повышении доверия к бренду, его открытости, социальной ответственности и репутационной устойчивости. Эта награда отмечает лидеров, способных выстраивать долгосрочные отношения с клиентами, партнёрами, обществом и регуляторами, формируя положительное восприятие бренда на локальном и международном уровнях.
        </p>
        <h3>
            <img src={CheckIcon} alt="" className="terms-section__pin-icon" />
             Критерии оценки:</h3>
        <ul className="terms-list">
          <li>Репутационный рост и устойчивость бренда:</li>
          <ul className="terms-list">
            <li>Рост или стабилизация доверия к бренду (Trust Index, NPS, CSI, бренд-оценки);</li>
            <li>Эффективные антикризисные коммуникации, превентивные меры, восстановление доверия после репутационного удара.</li>
          </ul>
          <li>Стратегия открытости и прозрачности:</li>
          <ul className="terms-list">
            <li>Внедрение практик прозрачной корпоративной коммуникации (ESG-отчётность, публичные диалоги, форумы);</li>
            <li>Работа с отзывами, вовлечённостью, репутацией в digital-среде, обратной связью от клиентов.</li>
          </ul>
          <li>Корпоративная социальная ответственность (CSR):</li>
          <ul className="terms-list">
            <li>Разработка и реализация социальных и экологических инициатив, продвигаемых от имени бренда;</li>
            <li>Влияние этих инициатив на восприятие бренда и вовлечённость аудитории.</li>
          </ul>
          <li>Публичное признание и охват:</li>
          <ul className="terms-list">
            <li>Отражение репутационных усилий в медиаполе (упоминания в СМИ, исследованиях, репутационных рейтингах);</li>
            <li>Участие в диалогах с государственными и отраслевыми институтами, лидирующая позиция в профессиональной этике.</li>
          </ul>
        </ul>
        <h3><img src={ListIcon} alt="" className="terms-section__pin-icon" />
         Формат подачи заявки (submission requirements):</h3>
        <ul className="terms-list">
          <li>Подробное описание инициатив CMO, направленных на повышение доверия и управления репутацией;</li>
          <li>Метрики доверия, охвата, обратной связи, оценки независимых агентств;</li>
          <li>Кейсы управления кризисами или построения открытых коммуникаций;</li>
          <li>Документы CSR-инициатив, примеры партнёрств с НКО или органами власти;</li>
          <li>Публикации в деловых и профильных медиа, включение в репутационные рейтинги.</li>
        </ul>
      </section>

      {/* Sustainability Marketing Leader */}
      <section className="terms-section">
        <h2 className="terms-section__title">
          <img src={SustainabilityIcon} alt="" className="terms-section__icon" />
         Sustainability Marketing Leader
        </h2>
        <p>
          Награда за выдающееся продвижение принципов устойчивого развития, ESG и социальной ответственности через стратегический и креативный маркетинг.
        </p>
                <h3><img src={PinIcon} alt="" className="terms-section__pin-icon" />
         Описание номинации</h3>
        <p>
          Присуждается маркетинговому лидеру, который интегрировал ценности экологической, социальной и управленческой устойчивости (ESG) в коммуникационную стратегию бренда, усилив как его репутацию, так и реальное влияние на общество и окружающую среду. Эта награда подтверждает роль маркетинга как инструмента позитивных изменений и долгосрочной ценности.
        </p>
        <h3>
            <img src={CheckIcon} alt="" className="terms-section__pin-icon" />
             Критерии оценки:</h3>
        <ul className="terms-list">
          <li>Интеграция ESG-стратегии в маркетинг:</li>
          <ul className="terms-list">
            <li>Маркетинговые инициативы, основанные на принципах устойчивого потребления, экологической ответственности, равенства и инклюзии;</li>
            <li>Влияние ESG-коммуникаций на восприятие бренда, уровень вовлечённости и доверия аудитории.</li>
          </ul>
          <li>Подтверждённые результаты и импакт:</li>
          <ul className="terms-list">
            <li>Показатели эффективности инициатив: рост лояльности, увеличение NPS, снижение негативных реакций, устойчивое позиционирование;</li>
            <li>Социальный и экологический вклад: проекты в области климата, образования, инклюзии, общественного блага.</li>
          </ul>
          <li>Внутренние и внешние трансформации:</li>
          <ul className="terms-list">
            <li>Влияние маркетинга на изменение корпоративных процессов, внедрение принципов ESG в повседневную деятельность бренда;</li>
            <li>Обучение сотрудников, партнёров, клиентов новым поведенческим моделям через коммуникации.</li>
          </ul>
          <li>Признание и публичность:</li>
          <ul className="terms-list">
            <li>Отражение инициатив в независимых ESG-рейтингах, рейтингах ответственного бизнеса, премиях за устойчивое развитие;</li>
            <li>Участие в международных конференциях и форумах по устойчивости, публикации в профильных изданиях.</li>
          </ul>
        </ul>
        <h3><img src={ListIcon} alt="" className="terms-section__pin-icon" />
         Формат подачи заявки (submission requirements):</h3>
        <ul className="terms-list">
          <li>Подробное описание ESG-инициатив, реализованных при участии CMO;</li>
          <li>Кейсы с визуализациями и измеримыми результатами;</li>
          <li>ESG-отчёты, исследования обратной связи, документы с подтверждением партнёрств;</li>
          <li>Упоминания в профильных и деловых медиа, премии за устойчивое развитие;</li>
          <li>Письма поддержки от партнёров, НКО, внутренних команд.</li>
        </ul>
      </section>

      {/* Team Leadership Excellence */}
      <section className="terms-section">
        <h2 className="terms-section__title">
          <img src={TeamIcon} alt="" className="terms-section__icon" />
         Team Leadership Excellence
        </h2>
        <p>
          Награда за выдающееся лидерство в развитии маркетинговой команды, формирование сильной корпоративной культуры и достижение высоких командных результатов.
        </p>
                <h3><img src={PinIcon} alt="" className="terms-section__pin-icon" />
         Описание номинации</h3>
        <p>
          Присуждается руководителю, который продемонстрировал высокую эффективность в управлении маркетинговыми командами, построении среды доверия, профессионального роста и вдохновения. Эта награда подтверждает значимость командного лидерства как ключевого фактора успеха в современных организациях.
        </p>
        <h3>
            <img src={CheckIcon} alt="" className="terms-section__pin-icon" />
             Критерии оценки:</h3>
        <ul className="terms-list">
          <li>Развитие и удержание команды:</li>
          <ul className="terms-list">
            <li>Стратегии найма, адаптации, развития и удержания талантов;</li>
            <li>Рост компетенций внутри команды, карьерные продвижения, низкий уровень текучести.</li>
          </ul>
          <li>Вовлечённость и корпоративная культура:</li>
          <ul className="terms-list">
            <li>Проведённые инициативы, направленные на мотивацию, командообразование и повышение вовлечённости сотрудников;</li>
            <li>Роль маркетинга в формировании культурных ценностей компании и укреплении внутрикорпоративной коммуникации.</li>
          </ul>
          <li>Управление мультифункциональными структурами:</li>
          <ul className="terms-list">
            <li>Эффективное руководство командами, включающими digital, бренд, аналитиков, SMM, PR и другие направления;</li>
            <li>Координация с внешними агентствами, подрядчиками, кросс-функциональными подразделениями.</li>
          </ul>
          <li>Подтверждённые результаты командной работы:</li>
          <ul className="terms-list">
            <li>Совместно достигнутые бизнес-результаты: реализованные проекты, показатели эффективности, внедрение изменений;</li>
            <li>Успешные кейсы командного взаимодействия, упомянутые в профильных медиа, премиях или внутренних отчётах.</li>
          </ul>
        </ul>
        <h3><img src={ListIcon} alt="" className="terms-section__pin-icon" />
         Формат подачи заявки (submission requirements):</h3>
        <ul className="terms-list">
          <li>Описание структуры команды и управленческого подхода;</li>
          <li>Примеры реализованных командных инициатив и проектов;</li>
          <li>BI-отчёты, HR-метрики, данные об удержании и росте сотрудников;</li>
          <li>Отзывы команды, пресс-релизы, публикации;</li>
          <li>Рекомендательные письма от членов команды, HR, коллег из других департаментов.</li>
        </ul>
      </section>

    </article>
  );
}
